<template lang="pug">
v-radio-group.pa-4(v-model='input')
    .radio.mb-4(
      v-for="(value, k) in answer_values"
      :key="k"
    )
      v-radio(
        :value="getValueParsed(value.value)"
      )
        template(v-slot:label)
          span(v-text="value.label")
          v-tooltip(
            v-if="value.info"
            max-width="300"
            bottom
          )
            template(v-slot:activator="{ on }")
              v-icon.ml-2(v-on="on") mdi-information-outline
            span(v-text="value.info")
</template>
<script>
export default {
  name: 'Radio',
  props: ['answer_values', 'value'],
  computed: {
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    getValueParsed(value) {
      // switch (value){
      //   case 'false':
      //   case 'False':
      //     return false
      //   case 'true':
      //   case 'True':
      //     return true
      //   default:
      //     return value
      // }
      return value
    }
  }
}
</script>